import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Neighbourhood } from '../model/story/neighbourhood.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NeighbourhoodService {
  private httpClient = inject(HttpClient);

  public getNeighbourhoodList(): Observable<Neighbourhood[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/areas`,
    ).pipe(
      map((responseList: any[]): Neighbourhood[] => (responseList ?? []).map(
        (response:any): Neighbourhood => Neighbourhood.createFromApi(response),
      )),
    );
  }
}
